<template>
	<div class="AI">
        <ReAiNavigate/>
		<h2>Пишем промпты</h2>
        <div>
            Модель
            <el-select 
						class="col-md-4 col-12 px-0 select-primary mr-2"
						v-model="model" 
						placeholder="Укажите модель"
						size="large"
						filterable
						clearable
					>
						<el-option
							class="select-primary"
							v-for="(m,index) in models"
							:key="index"
							:label="m.name"
							:value="m.model"
							>
						</el-option>
					</el-select>
        <base-button type="primary" simple v-on:click="loadModels">Перезагрузить</base-button>
        </div>
        <div ref="texts">
            <h4>Тексты</h4>
            <div v-if="preload">Слушаем музыкантов на разогреве модели {{ model }}</div>
            <div class="container-fluid">
                <!--
                <REAIText v-for="t in text" :key="t.id" :text="t" :class="{ flash: t.process }" @change="updateText($event)" @remove="removeText(t)"/>
                -->
                <div v-for="t in text" :key="t.id" :class="{ flash: t.process }">
                    <div class="dflex">
                        <textarea v-model="t.text" class="flex1 form-control"></textarea>
                        <base-button type="danger" simple v-on:click="removeText(t)">Удалить</base-button>
                        <div class="flex1">

                            <REAIQueue v-for="id in t.queue" :key="id" :id="id" class="prewrap answer" v-on:close="(id)=>removeTextResult(t,id)"/>
                        </div>
                    </div>
                </div>
            </div>
            <base-button type="success" simple v-on:click="AddText()">Добавить</base-button>
        </div>
        <div class="action-buttons dflex">
                <div v-for="btn in buttons" :key="btn.id">
                    <base-button
                    :type="btn.type"
                    simple
                    :disabled="btn.disabled"
                    @click="btn.action"
                    >
                    {{ btn.label }}
                    <ReBackTimer :time="model_expire" v-if="btn.showTimer && model_expire" />
                    </base-button>
                </div>
            </div>
        <div>
            <h4>Вопросы</h4>
            <div class="container-fluid">
                Общий текст (добавится после вопроса):<input type="text" v-model="prompt"/>
                <div class="row">
                    <div class="col-3">Температура: {{ options.temp }}</div>
                    <div class="col-9"><el-slider v-model="options.temp" :min="0" :max="1" :step="0.01"></el-slider></div>
                </div>
                <div class="row">
                    <div class="col-3">Сид</div>
                    <div class="col-9"><el-slider v-model="options.seed" :max="4294967296" show-input></el-slider></div>
                </div>
                <div class="row">
                    <div class="col-3">Токенов прогноза</div>
                    <div class="col-9"><el-slider v-model="options.num_predict" :min="-1" :max="128000" show-input></el-slider></div>
                </div>
                <div class="row">
                    <div class="col-3">Пенальти повтора: {{ options.repeat_penalty }}</div>
                    <div class="col-9"><el-slider v-model="options.repeat_penalty" :min="0" :max="10" :step="0.05"></el-slider></div>
                </div>
                <div class="row">
                    <div class="col-3">Разнообразие:</div>
                    <div class="col-9"><el-slider v-model="options.top_k" :min="0" :max="1000" show-input></el-slider></div>
                </div>
                <div class="row">
                    <div class="col-3">Фокус внимания:{{ options.top_p }}</div>
                    <div class="col-9"><el-slider v-model="options.top_p" :min="0" :max="1" :step="0.01"></el-slider></div>
                </div>
            </div>
            <!--
            <div v-for="q in query"  :key="q.id" class="query">
                <div class="dflex">
                    <div>
                        <input type="checkbox" v-model="q.active"/> Вопрос:<br/><textarea v-model="q.text" rows="5" class="form-control"></textarea>
                    </div>
                    <div class="query-props flex1">
                        Результаты:<br/>
                        <div v-for="p in q.props" class="query-prop form-inline" :key="p.id">
                            <input type="checkbox" v-model="p.required"/>*обяз. поле:  <input type="text" v-model="p.name" class="form-control col-md-4 inline"/>, тип 
                            <div class="inline col-md-4 col-12">
                                <el-select 
                                    class="col-md-12 col-12 px-0 select-primary mr-2"
                                    v-model="p.type" 
                                    placeholder="Укажите тип"
                                    size="large"
                                    filterable
                                    clearable
                                >
                                    <el-option
                                        class="select-primary"
                                        v-for="(m) in Object.keys(types)"
                                        :key="m"
                                        :label="types[m]"
                                        :value="m"
                                        >
                                    </el-option>
                                </el-select>
                                <template v-if="p.type=='enum'||p.type=='arrayEnum'">
                                    <input type="text" v-model="p.enum" placeholder="Список вариантов через запятую" class="form-control col-md-12 col-12 mt-2"/>
                                </template>
                            </div>
                            <base-button type="danger" simple  v-on:click="removeQueryProp(q,p)">X</base-button>
                        </div>
                        <div class="dflex">
                            <base-button type="success" simple  v-on:click="AddQueryProp(q)">Добавить результат</base-button>
                        </div>
                    </div>
                    <div>
                        <base-button type="danger" simple  v-on:click="removeQuery(q)">Удалить вопрос</base-button>
                        <br/>
                        <base-button type="warning" simple  v-on:click="copyQuery(q)">Дублировать</base-button>
                    </div>
                </div>
                
                <div class="prewrap ai-query" v-show="q.text>''">
                    {{ JSON.stringify(formatQuery(q)) }}
                </div>
                
                
            </div>
            -->
            <REAIQuery 
                v-for="q in query" 
                :key="q.id" 
                :query="q" 
                :prompt="prompt"
                :filterProps="propList"
                @clone="copyQuery($event)"
                @remove="removeQuery($event)"
                @change="updateQuery($event)"
            />
            <base-button type="success" simple  v-on:click="AddQuery()">Добавить вопрос</base-button>
            <!-- 
            <div>
                <base-button type="primary" simple  v-on:click="load()">Загрузить</base-button> - 
                <base-button type="success" simple  v-on:click="save()">Сохранить</base-button> - 
                <base-button type="primary" simple  v-on:click="download()">Скачать</base-button> - 
                <base-button type="danger" simple  v-on:click="runImport()">Импортировать</base-button> - 
                <base-button type="info" simple  v-on:click="runQuery()" :disabled="this.model_expire">Выполнить запросы <ReBackTimer :time="model_expire" v-if="model_expire"/></base-button>
            </div>
            -->
            <div class="action-buttons dflex">
                <div v-for="btn in buttons" :key="btn.id">
                    <base-button
                    :type="btn.type"
                    simple
                    :disabled="btn.disabled"
                    @click="btn.action"
                    >
                    {{ btn.label }}
                    <ReBackTimer :time="model_expire" v-if="btn.showTimer && model_expire" />
                    </base-button>
                </div>
            </div>
            <div class="logs">
                <h4>Запрос/ответ</h4>
                <div v-for="(l,i) in logs" class="dflex" :key="i">
                    <div class="prewrap answer col-8">{{ JSON.stringify(l[0], null, 2)}}</div>
                    <div class="prewrap answer col-4">{{ JSON.stringify(l[1], null, 2)}}</div>
                </div>
            </div>
        </div>
		
	</div>
</template>

<script>
    import { Select, Option, Button, Slider } from 'element-ui';
    import ReBackTimer from '../our_components/ReBackTimer.vue';
    import REAIQueue from '../our_components/ai/REAIQueue.vue';
    // import REAIText from '../our_components/ai/REAIText.vue';
    import REAIQuery, { formatQuery } from '../our_components/ai/REAIQuery.vue';
    import ReAiNavigate from '../our_components/ai/ReAiNavigate.vue';
	export default {
		name: 'AI',
		components: {
            [Option.name]: Option,
            [Select.name]: Select,
            [Button.name]: Button,
            [Slider.name]: Slider,
            ReBackTimer,
            REAIQueue,
            // REAIText,
            REAIQuery,
            ReAiNavigate,
        },
		props: {
			
		}, 
		
		data() {
			return {
				text:[],
                logs:[],
                
                model:'qwen3:14b',
                model_expire: false,
                models:[],
                query:[
                    // {text:'Краткая сводка разговора',props:[{id:1,required:true, name:'summary', type:"string"}]},
                    // {text:'Район или метро',props:[{id:1,required:false, name:'address', type:"string"}]},
                    // {text:'Интересует срочный выкуп?',props:[{id:1,required:false, name:'fire', type:"boolean"}]},
                    // {text:'Сколько собственников в квартире, кто они?',props:[{id:1,required:false, name:'owners', type:"integer"}]},

                ],
                types:{
                    string:'Строка',
                    integer:'Число',
                    number:'Вещественное',
                    boolean:'Логический',
                    enum:'Перечисление',
                    date:'Дата',
                    datetime:'Дата и Время',
                    time:'Время',
                    arrayString:'массив строк',
                    arrayInt:'Массив чисел',
                    arrayEnum:'Массив перечислений',
                    // test_callView:'Звонок или встреча',
                },
                prompt:'',
                options:{
                    temp: 0.8,
                    seed: 0,
                    num_predict: -1,
                    repeat_penalty: 1.1,
                    top_k: 40,
                    top_p: 0.9,
                },
                buttons: [
                    { id: 'load', label: 'Загрузить', type: 'primary', action: this.load },
                    { id: 'save', label: 'Сохранить', type: 'success', action: this.save },
                    { id: 'download', label: 'Скачать', type: 'primary', action: this.download },
                    { id: 'import', label: 'Импортировать', type: 'danger', action: this.runImport },
                    {
                    id: 'query',
                    label: 'Поставить в очередь',
                    type: 'info',
                    action: this.runQuery,
                    showTimer: true,
                    // disabled вычисляется динамически
                    }
                ],
                preload:false,
    		}
		},
        computed:{
            propList(){
                let list=[];
                this.query.forEach(q=>{
                    q.props.forEach(p=>{
                        let t=p.name.trim();
                        if(t>'' && list.indexOf(t)===-1)
                        list.push(t);
                    })
                });
                return list;
            },
        },
		methods: {
            getId(){
                return this.$GVO.getId();
            },
            /*
            propsType(type,p){
                switch(type){
                    case 'arrayString': return {type:'array', items:{type:'string'}};
                    case 'arrayInt': return {type:'array', items:{type:'integer'}};
                    case 'date': return {type:'string', format:'date'};
                    case 'datetime': return {type:'string', format:'datetime',
                        // "pattern": "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$"
                    };
                    case 'time': return {type:'string', format:'time',"pattern": "^\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?$"};
                    case 'enum': return {type:'string', enum:String(p.enum).split(',').map(v=>v.trim())};
                    case 'arrayEnum': return {type:'array', items:{type:'string', enum:String(p.enum).split(',').map(v=>v.trim())}};
                    
                }
                return {type}
            },*/
            formatQuery(q){
                return formatQuery(q, this.prompt);
                /*
                let r={message:{role:'user', content:q.text}}
                if(this.prompt>'') r.message.content+=' '+this.prompt;
                if(q.filters){
                    let f = q.filters.filter(p=>p.name.trim()>''&&p.value.trim()>'');
                    if(f.length>0){
                        r.filters={};
                        f.forEach(filter=>r.filters[filter.name.trim()]=filter.value.split(',').map(t=>t.trim()))
                    }
                }
                let pr = q.props.filter(p=>p.name>'');
                if(pr.length>0){
                    let f={type:'object', properties:{}, required:[]}
                    pr.forEach(p=>{
                        f.properties[p.name]=this.propsType(p.type, p);
                        if(p.required) f.required.push(p.name);
                    })
                    r.format = f;
                }
                return r;
                */
            },
			AddText(text){
                this.text.push({
                    id: this.getId(),
                    text:text||'',
                    result:[],
                    json:{},
                    process: false,
                    queue:[],                    
                })
            },
            removeText(t){
                let i = this.text.indexOf(t);
                if(i>-1) this.text.splice(i,1);
            },
            updateText(updatedItem) {
                // console.log('udpateText',updatedItem);
                const index = this.text.findIndex(item => item.id === updatedItem.id);
                if (index !== -1) {
                    // Заменяем объект целиком — это важно для реактивности в Vue 2
                    this.$set(this.text, index, updatedItem);
                    // или: this.text.splice(index, 1, updatedItem);
                }
            },
            removeTextResult(text,id){
                let i = text.queue.indexOf(id);
                if(i>-1) text.queue.splice(i,1);
            },
            async loadModels(){
                this.models=[{name:'рабочая гемма2-9Бэ',model:'gemma2:9b'}];
                // let m = await this.$GVO.Api.AI.models();
                // console.log(m);
                // if(m.success == true){
                //     this.models=m.data.models.filter(m=>m.size<8000000000);
                   
                if(this.model=='' && this.models.length>0) this.model = this.models[0].model
                // }
            },
			AddQuery(text){
                this.query.push({
                    id: this.getId(),
                    text:text||'',
                    props:[],
                    filters:[],
                    active: true,
                   
                })
            },
            updateQuery(query) {
              const index = this.query.findIndex(item => item.id === query.id);
              if (index !== -1) {
                // Заменяем объект целиком — это важно для реактивности в Vue 2
                this.$set(this.query, index, query);
                // или: this.query.splice(index, 1, query);
              }
            },
            removeQuery(q) {
                const index = this.query.findIndex(item => item.id === q.id);
                if (index === -1) return;
                // Создаём новый массив без элемента (иммутабельно)
                this.query = [
                    ...this.query.slice(0, index),
                    ...this.query.slice(index + 1)
                ];
            },

            copyQuery(q) {
                const index = this.query.findIndex(item => item.id === q.id);
                if (index === -1) return;

                // Клонируем объект (предполагается, что $GVO.unlinkObject делает глубокую копию)
                const nq = this.$GVO.unlinkObject(q);
                nq.id = this.getId(); // новый уникальный ID

                // Вставляем копию ПЕРЕД оригиналом (или после — как вам нужно)
                this.query = [
                    ...this.query.slice(0, index),
                    nq,
                    ...this.query.slice(index) // вставляем перед → оригинальный остаётся на своём месте
                ];
            },
            AddQueryProp(q){
                let i = this.query.indexOf(q);
                if(i==-1) return;
                this.query[i].props.push({
                    id: this.getId(),
                    name:'',
                    required: false,
                    type:'string',
                })
            },
            removeQueryProp(q,p){
                let i = this.query.indexOf(q);
                if(i==-1) return;
                let ip = this.query[i].props.indexOf(p);
                if(ip>-1) this.query[i].props.splice(ip,1);
            },
            async runQuery(){
                this.text.forEach(t=>{
                    t.result=[];
                    t.json={};
                });
                this.logs=[];
                this.save();
                this.$refs.texts.scrollIntoView({ behavior: 'smooth' });
                /*
                try{
                    this.preload=true;
                    await this.$GVO.Api.AI.prepare({model: this.model});
                    this.preload=false;
                }catch(e){
                    this.preload=false;
                    this.$GVO.showAlert('Ошибка',`Прогрев длится больше чем надо. Попробуйте позже`);
                    return;
                }
                */
                this.process=true;
                for(let t of this.text){
                    t.process=true;
                    if(!this.process) break;
                    let ai_query=this.query.filter(q=>q.text>''&&q.active).map(this.formatQuery);
                    if(ai_query.length==0){
                        this.$GVO.showAlert('Вы что хотите','Вы не задали ни одного вопроса, а уже хотите получить ответ 42?');
                        return;
                    }
                    // console.log(ai_query,this.query);return;
                    let plan = await this.$GVO.Api.AI.plan({
                        model: this.model, 
                        text: t.text,
                        id: t.id,
                        query: ai_query,
                        options: this.options,
                    });
                    if(plan.success==true){
                        t.queue.push(Number(plan.data));
                    }
                    /*
                    for(let q of this.query){
                        if(!this.process) break;
                        if(q.text>'' && q.active){
                            let qr = this.formatQuery(q);
                            try{
                                let r = await this.$GVO.Api.AI.chat({
                                    model: this.model, 
                                    text: t.text,
                                    query: qr
                                });
                                if(r.success==true){
                                    let j = this.getJson(r.data.message.content);
                                    if(r.data.query) {
                                        let {query, ...ans} = r.data
                                        this.logs.push([query,ans]);
                                    }
                                    if(typeof j != 'string'){
                                        t.json = {...t.json, ...j};
                                    }else{
                                        t.result.push(this.getJson(r.data.message.content));
                                    }
                                }else{
                                    t.result.push(r);
                                }
                            }catch(e){
                                console.error(e);
                                t.result.push('ОшИБКА:'+e.message);
                            }
                        }
                    }*/
                    t.process=false;
                }
                this.process = false;
                this.save();
                // this.modelExpire();
            },
            getJson(j){
                try{
                    return JSON.parse(j);
                }catch(e){
                    return j
                }
            },
            getSaveData(){
                let ai = {
                    model: this.model,
                    text: this.text,
                    query: this.query,
                    prompt: this.prompt,
                    options: this.options
                }
                return ai;
            },
            download(){
                const ai = this.getSaveData();
                // Преобразуем объект в JSON с отступами для читаемости (опционально)
                const jsonStr = JSON.stringify(ai, null, 2);
                
                // Создаём Blob с типом application/json
                const blob = new Blob([jsonStr], { type: 'application/json' });
                
                // Генерируем временный URL
                const url = URL.createObjectURL(blob);
                
                // Создаём ссылку для скачивания
                const a = document.createElement('a');
                a.href = url;
                a.download = 'ai-config.json'; // Имя файла при скачивании
                
                // Добавляем в DOM, кликаем и удаляем
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                
                // Освобождаем память
                URL.revokeObjectURL(url);
            },
            save(){
                const ai = this.getSaveData();
                localStorage.setItem('AI', JSON.stringify(ai));
            },
            runImport(){
                this.$GVO.showPrompt('Загрузите настройки','содержимое файла').then(result=>{
					if(result.value){
                        try{
                            this.loadConfig(result.value);
                        }catch(e){
							this.$GVO.showAlert('Ошибка',`Не удалось прочитать настройки`);
						}
					}
				})
            },
            loadConfig(config){
                let ai = JSON.parse(config);
                if(ai){
                    this.model = ai.model;
                    this.text = ai.text;
                    this.query = ai.query;
                    this.prompt = ai.prompt;
                    if(ai.options){
                        this.options= {...this.options, ...ai.options}
                    }
                }
                for(let t of this.text){
                    if(!Object.prototype.hasOwnProperty.call(t,'queue'))
                        t.queue=[];
                    t.process=false;
                }
                for(let q of this.query){
                    if(!Object.prototype.hasOwnProperty.call(q,'filters'))
                        q.filters=[];
                }
            },
            load(){
                let AI = localStorage.getItem('AI');
                if(AI){
                    try{
                        this.loadConfig(AI);
                    }catch(e){
                    }
                }
            },
            modelExpire(){
                clearTimeout(this.mexp);
                this.model_expire=new Date(Date.now()+10000).toISOString();
                this.m_exp = setTimeout(()=>{this.model_expire=false},10000)
            }
		},
		mounted() {
			this.loadModels();
            
            this.load();
            // this.modelExpire();
		}
	};
</script>

<style scoped lang="scss">
    .prewrap{
        white-space:pre-wrap;
    }
    .dflex{
        display:flex;
    }
    .flex1{flex:1;}

    .query{
        // padding-left:1em;
    }
    .query-props{
        padding-left:2em;
    }
    .query-prop{
        padding-left: 2em;
    }
    .answer{
        border: 1px solid #01b0e0;
        margin:3px;
        padding:5px;
        border-radius:5px;
    }

    .ai-query{
        opacity: 0.5;
    }

    .action-buttons>div:not(:last-child):after{
        content:" - ";
        padding-right: 0.25em;
    }
.flash {
  animation: flash-opacity 3s infinite;
}

@keyframes flash-opacity {
  0%, 100% { opacity: 1; }
  50%      { opacity: 0.3; }
}
</style>
